import { CommonModule } from '@angular/common'
import { Component, inject, signal } from '@angular/core'

import { Store } from '@ngrx/store'
import { BadgeModule } from 'primeng/badge'
import { DialogModule } from 'primeng/dialog'
import { ImageModule } from 'primeng/image'
import { ProgressBarModule } from 'primeng/progressbar'
import { TooltipModule } from 'primeng/tooltip'

import { AiSelectors } from '@flowx/designer/modules/new-ai/store/ai.selectors'

import { AgentLogComponent } from '../agent-log/agent-log.component'
import { AgentReasoningComponent } from '../agent-reasoning/agent-reasoning.component'

@Component({
  selector: 'flx-ai-agent-footer',
  imports: [
    CommonModule,
    DialogModule,
    ImageModule,
    ProgressBarModule,
    TooltipModule,
    BadgeModule,
    AgentReasoningComponent,
    AgentLogComponent,
  ],
  templateUrl: './agent-footer.component.html',
  styleUrls: ['./agent-footer.component.scss'],
  standalone: true,
})
export class AgentFooterComponent {
  #store = inject(Store)

  logType = signal<'agentLog' | 'reasoning'>('agentLog')
  windowState = signal<'open' | 'closed'>('closed')

  reasoningLogs = this.#store.selectSignal(AiSelectors.reasoningLogs)
  logs = this.#store.selectSignal(AiSelectors.logs)

  changeWindowState(): void {
    this.windowState.set(this.windowState() === 'open' ? 'closed' : 'open')
  }
}
